import SignatureEditor from "./SignatureEditor";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import APIS from "../../constant/Endpoint";
import useGetHook from "../../hooks/useUserServiceGetHook";

export default function SignatureSettings({ username }) {
  const { data: signature, isLoading } = useGetHook({
    queryKey: [`signature`],
    url: `${APIS.EMAIL}signature/`,
    params: {},
  });

  return (
    <div className={tw`min-w-full mx-auto p-2`}>
      <div
        className={tw`bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden`}
      >
        {/* Header Section */}
        <div
          className={tw`bg-gradient-to-r from-blue-50 to-indigo-50 px-6 py-5 border-b border-gray-200`}
        >
          <div className={tw`flex items-center gap-3`}>
            <div className={tw`p-2 bg-red-500 rounded-lg shadow-sm`}>
              <svg
                className={tw`w-6 h-6 text-white`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                />
              </svg>
            </div>
            <div>
              <h2 className={tw`text-2xl font-semibold text-gray-900`}>
                Email Signature
              </h2>
              <p className={tw`text-sm text-gray-600 mt-0.5`}>
                Customize your professional email signature
              </p>
            </div>
          </div>
        </div>

        {/* Content Section */}
        <div>
          {isLoading ? (
            <div
              className={tw`flex flex-col items-center justify-center py-16`}
            >
              <div className={tw`relative`}>
                <div
                  className={tw`h-16 w-16 rounded-full border-4 border-gray-200 border-t-red-500 animate-spin`}
                />
                <div
                  className={tw`absolute inset-0 h-16 w-16 rounded-full border-4 border-transparent border-t-red-300 animate-spin`}
                  style={{ animationDuration: "1.5s" }}
                />
              </div>
              <p className={tw`mt-4 text-sm text-gray-500 font-medium`}>
                Loading your signature...
              </p>
            </div>
          ) : (
            <div className={tw`animate-fadeIn`}>
              <SignatureEditor
                value={signature?.signature}
                username={username}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
